export default {"src":"/_next/static/media/veryHappyInactive_24.057d0848.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};